/**
 * Tooltip plugin — port 1:1 din legacy common.js lines 1590-1660.
 * Citeste data-tooltip + data-color, afiseaza .sp-tooltip pe hover (desktop)
 * sau pe tap (mobile).
 */

import { $ } from '../core/selector.js';
import { device } from '../core/device.js';

Node.prototype.Tooltip = function (this: Node): void {
    const el = this as HTMLElement;
    const text = el.dataset['tooltip'];
    let color = el.dataset['color'];
    if (!text) return;
    if (!color) color = 'white';

    let ui: HTMLElement | null = null;

    this.on(device.isMobile ? 'click' : 'mouseover', function (this: Element, e: Event) {
        e.stopPropagation();
        const target = this as HTMLElement;

        ($('.sp-tooltip') as HTMLElement | null)?.remove();
        ui = $(`<div class="sp-tooltip sp-color-${color}">${text}</div>`) as HTMLElement | null;
        if (!ui) return;
        document.body.append(ui);

        const offsetT = target.offset();
        if (offsetT.left + ui.clientWidth / 2 + 20 < window.innerWidth) {
            ui.css({
                top:  `${Math.round(offsetT.top - ui.clientHeight - 8)}px`,
                left: `${Math.round(offsetT.left - ui.clientWidth / 2 + target.clientWidth / 2)}px`,
            });
        } else {
            ui.css({
                top:  `${Math.round(offsetT.top - ui.clientHeight - 8)}px`,
                left: '25px',
            });
            ui.classList.add('fixed');
        }
    });

    if (device.isMobile) {
        document.body.on('click', function () {
            if (ui) ($('.sp-tooltip') as HTMLElement | null)?.remove();
        });
    } else {
        this.on('mouseout', function () {
            if (ui) ui.remove();
        });
    }
};

NodeList.prototype.Tooltip = function (this: NodeList) {
    this.forEach((node) => { (node as Node).Tooltip(); });
    return this;
} as NodeList['Tooltip'];
